export const METABASE_STAT_KEYS = {
  callTotals: "call-totals",
  callsByDay: "calls-by-day",
  callsByType: "calls-by-type",
  smsByDay: "sms-by-day",
  webchatByDay: "webchat-by-day",
  callDetails: "call-details",
} as const;

export type MetabaseStatKey = (typeof METABASE_STAT_KEYS)[keyof typeof METABASE_STAT_KEYS];

const METABASE_STAT_KEY_SET = new Set<string>(Object.values(METABASE_STAT_KEYS));

export function isMetabaseStatKey(value: string): value is MetabaseStatKey {
  return METABASE_STAT_KEY_SET.has(value);
}

export function buildMetabaseStatApiPath(statKey: MetabaseStatKey): string {
  return `/api/stats/${statKey}`;
}
